export default function SkeletonCard() {
  return <div className="h-[18rem] flex-1 rounded-xl skeleton"></div>;
}
